// import {
//   faBiking,
//   faSchool,
//   faRoute,
//   faLandmark,
//   faPlaceOfWorship,
//   faBook,
// } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
// import bikeRack from "../../bike_rack.svg";
import React, { useState } from "react";

// export interface LayerButtonIcon {
//     icon:any = faBiking || faTable
// }

const LayerButton = (props) => {
  const isEnabled = props.enabled;
  const [enabled, setEnabled] = useState(
    isEnabled ? isEnabled : false
  );

  const handleClick = () => {
    if (!enabled) {
      props.onEnable();
    } else {
      props.onDisable();
    }

    setEnabled(!enabled);
  };

  // let icon = null;

  // switch (props.type) {
  //   case "book":
  //     icon = faBook;

  //     break;
  //   case "biking":
  //     icon = faBiking;

  //     break;
  //   case "school":
  //     icon = faSchool;

  //     break;
  //   case "route":
  //     icon = faRoute;

  //     break;
  //   case "landmark":
  //     icon = faLandmark;

  //     break;
  //   case "placeOfWorship":
  //     icon = faPlaceOfWorship;

  //     break;

  //   default:
  //     icon = faBiking;
  //     break;
  // }

  // const className = "w-12 h-12 " + (enabled ? "bg-primary" : "bg-gray-400");
  return (
    <>
      <button
        className={classNames(
          !enabled ? "bg-primary text-secondary" : "bg-secondary text-primary",
          "w-8 sm:w-14 h-8 sm:h-14 transition-all duration-300 ease-in-out rounded-full overflow-auto"
        )}
        arial-label={props.label}
        aria-labelledby={`${props.type}-label`}
        onClick={handleClick}
      >
        <span id={`${props.type}-label`} className="sr-only">
          {props.label}
        </span>
        {props.type === "route" ? (
          <div className="flex items-center justify-center object-center">
            <svg
              id="svg2"
              className="h-6 sm:h-9 w-6 sm:w-9 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              x={0}
              y={0}
              viewBox="0 0 16 16"
              style={{
                enableBackground: "new 0 0 16 16",
              }}
              xmlSpace="preserve"
              {...props}
            >
              {/* <style>{".st1{fill:#ff0008}"}</style> */}
              <path
                className="st1"
                d="M15.8 10.5c-.1.7-.5 1.2-1 1.7-.5.4-.9.9-1.4 1.4-.1.1-.2.1-.3 0l-1.8-1.8c-.6-.7-.8-1.6-.4-2.5.3-.9 1-1.4 2-1.6 1.3-.2 2.5.7 2.8 2.1v.1c.1.1.1.3.1.6zm-2.5-1.2c-.4 0-.7.3-.7.7 0 .4.3.7.8.7.4 0 .7-.3.7-.7-.1-.3-.4-.7-.8-.7zM7.3 12.7h3.6c.2 0 .2 0 .2.2v.6c0 .1 0 .2-.2.2H3.7c-.9 0-1.6-.4-2-1.2-.5-1.3.3-2.8 1.6-3H7.9c.6 0 1-.3 1.1-.8.2-.7-.3-1.4-1-1.4H5.1c-.3 0-.3 0-.3-.2v-.5c0-.1 0-.2.1-.2H8c.8 0 1.4.5 1.8 1.2.3.8.2 1.5-.3 2.1-.4.5-1 .7-1.7.7H3.6c-.4 0-.8.2-1 .5-.4.8.1 1.7 1 1.7 1.3.1 2.5.1 3.7.1zM.2 3.7c0-1.3 1-2.4 2.3-2.5 1.4-.1 2.5.9 2.7 2.2.1.8-.2 1.5-.8 2.1-.5.6-1 1.1-1.6 1.6-.1.1-.2.1-.2 0C2 6.6 1.5 6 .9 5.5.5 5 .2 4.4.2 3.7zM2.7 3c-.4 0-.8.3-.8.7 0 .4.3.7.7.7.4 0 .8-.3.8-.7 0-.4-.3-.7-.7-.7z"
              />
            </svg>
          </div>
        ) : props.type === "bike_rack" ? (
          <div className="flex items-center justify-center object-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 901 380.06"
              className="h-6 sm:h-9 w-6 sm:w-9  fill-current"
              {...props}
              style={{
                enableBackground: "new 0 0 16 16",
              }}
            >
              <path d="M876 330.06h-45.34c-4.5-84.23-31.73-162.83-77.83-223.53-25.12-33.07-54.53-59.13-87.41-77.44C630.76 9.79 593.85 0 555.71 0s-71.46 8.87-104.64 26.35C417.92 8.91 382.79.06 346.54.06c-38.14 0-75.06 9.79-109.72 29.09-32.88 18.31-62.29 44.37-87.41 77.44-46.09 60.68-73.31 139.26-77.82 223.47H25c-13.81 0-25 11.19-25 25s11.19 25 25 25h851c13.81 0 25-11.19 25-25s-11.19-25-25-25ZM713.02 136.77c39.6 52.14 63.19 120.02 67.56 193.29H621.5c-4.51-84.2-31.74-162.78-77.82-223.47-13.48-17.74-28.2-33.45-44.02-47.04 18.13-6.29 36.92-9.56 56.05-9.56 58.95 0 114.81 30.82 157.31 86.78ZM451.08 84.88c19.1 13.6 36.88 31.01 52.78 51.95 39.58 52.12 63.18 119.98 67.56 193.22H330.83c4.37-73.27 27.97-141.15 67.56-193.29 15.88-20.9 33.62-38.3 52.69-51.89Zm-261.85 51.95c42.5-55.96 98.37-86.78 157.31-86.78 19.09 0 37.85 3.25 55.94 9.52-15.78 13.57-30.47 29.24-43.91 46.95-46.1 60.7-73.33 139.3-77.83 223.53H121.67c4.38-73.24 27.97-141.1 67.56-193.22Z" />
            </svg>
          </div>
        ) : props.type === "green_area" ? (
          <div className="flex items-center justify-center object-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 sm:h-9 w-6 sm:w-9  fill-current"
              style={{
                enableBackground: "new 0 0 16 16",
              }}
              // width={368}
              // height={368}
              viewBox="0 0 276 276"
              {...props}
            >
              <path d="M209.5 39.9c-1.6.4-4 1.3-5.1 1.9-2.9 1.5-8.4 7.9-8.4 9.7 0 1-1.1 1.5-3.2 1.5-4.1 0-10.6 3-13.5 6.1-3.2 3.5-4.5 7.7-4.2 13.6.2 4.7 0 5.4-2.9 8.1-4.1 3.8-5.4 7.4-5.4 14.4.1 3.9-.3 5.8-1.3 6.2-.7.2-2.6 2.6-4.2 5.3-3.8 6.6-3.9 14 0 20.5 1.5 2.6 4 5.4 5.5 6.3 2.3 1.4 3 2.8 3.9 7.6 1.3 6.9 4.6 11.7 10.4 15.6 3.2 2.1 5.5 2.7 12 3.1l7.9.5V225h-17.9l1.6-2.8c3.6-6.3-2.4-8.7-7.2-3l-2.7 3.2-2.3-2.8c-2.4-3-5.1-3.2-6.9-.4-.8 1.3-.8 2.3.2 3.8 1.2 1.9 1 2-6.3 2H152v-22h8.4c4.6 0 9.1-.3 10-.6 1.3-.5 1.6-2.4 1.6-10.4 0-9.7 0-9.8-3.1-12.4-2.9-2.5-3.6-2.6-15-2.6H142v-17h7.3c4.3 0 7.8-.5 8.5-1.2.8-.8 1.2-4.7 1.2-11 0-11.5-.3-11.8-10.2-11.8-5.2 0-6.5-.3-7.6-2-.7-1.1-2.1-2-3.2-2-1 0-2.4.9-3 2-1 1.9-2.1 2-34 2-28.1 0-33-.2-33-1.4 0-.8-.5-1.8-1.1-2.1-1.6-1.1-5.9.4-5.9 2 0 1.2-1.5 1.5-7.3 1.5-4.3 0-7.8.5-8.5 1.2-1.6 1.6-1.6 20 0 21.6.7.7 4.2 1.2 8.5 1.2H61v17H49.5c-6.4 0-12.5.5-13.9 1.1-3.7 1.7-5.6 6.7-5.6 14.4 0 10.2.3 10.5 11.5 10.5H51v22h-6.7c-6.3 0-6.5-.1-5-1.8 2-2.2 2.2-4.3.5-6-1.9-1.9-3.5-1.4-6.7 2-2.9 3.1-3.1 3.2-4.4 1.4-2-2.8-6.1-1.8-6.5 1.6-.3 2.5-.7 2.8-4.1 2.8-2 0-4.2.5-4.9 1.2-1.8 1.8-1.4 4.6.7 5.8 2.7 1.4 249.5 1.4 252.2 0 4.2-2.3 1.6-7-3.9-7h-3.4l2.6-3.1c3-3.6 3.1-4.2 1-6.3-2.3-2.4-3.4-2-7.9 2.4l-4.2 4.1-2.7-4.1c-1.4-2.2-3-4-3.5-4-4.2 0-5.4 4.1-2.5 8.5l1.6 2.5h-18.1l-.3-9.1c-.2-7.3-.6-9.4-2-10.2-1.2-.8-2.1-.7-3.2.2-1.2 1-1.6 3.3-1.6 10.2v8.9h-10v-65h10l.2 18.1c.3 15.7.5 18.3 2 19.2 1.2.8 2.1.7 3.2-.2 1.4-1.1 1.6-4.1 1.6-19.2V160h5.8c8.7 0 13.1-1.6 18.3-6.9 4.6-4.5 6.9-9.6 6.9-15.2 0-1.7.8-2.9 2.4-3.7 4.6-2.1 9.6-11 9.6-17 0-4.5-2.3-10.2-5.7-14.2-2.8-3.3-3.3-4.5-2.8-6.9 1-4.5-1.2-10.6-5.2-14.8-2-2.1-3.6-4.3-3.4-4.8.8-2.8 0-10.7-1.2-13.2-3-5.7-10.4-10.3-16.6-10.3-2.1 0-3-.6-3.4-2.1-.4-1.6-1.2-2-3.4-1.7-3.2.4-4 2.6-2.3 6.7 1.3 3.4 4.7 5.1 9.8 5.1 8 .1 12.5 8.1 8.7 15.4-1.9 3.6-1.1 6.4 2.1 7.2 5.9 1.5 9.1 9.6 6.2 15.9-1.1 2.5-.9 2.9 3.6 6.9 4.6 3.9 4.9 4.6 5.4 9.7.4 4.9.1 5.9-2.3 8.7-1.5 1.8-4.3 3.9-6.1 4.7-3.3 1.4-3.4 1.6-3.4 7.2 0 4-.6 6.8-2 9-3.6 6-5.2 6.3-33.1 6.3-23.5 0-25.4-.1-28.4-2-4.2-2.6-6.5-7.5-6.5-13.9 0-4.9-.1-5.1-4-7.1-10.1-5.1-10.6-18.5-.9-23.5 2.8-1.5 3-2 2.4-4.8-1.2-5.5-1-11.4.5-13.1.7-1 3.1-2.6 5.2-3.7 4.1-2.1 4.6-3.9 2.3-7.9-2.4-4.3-1.8-7.9 1.9-11.6 2.6-2.6 4.2-3.4 7-3.4 5.4 0 9.2-2.4 10.6-6.5 1.4-4.3 4.8-6.7 10.4-7.5 3.6-.4 4.1-.9 4.4-3.2.3-2.2-.2-3-2.3-3.8-1.4-.5-2.7-1-2.8-.9-.1.1-1.5.4-3.2.8zM151 148.5v4.5l-49.7-.2-49.8-.3-.3-4.3-.3-4.2H151v4.5zm-17 20v8.5H68v-17h66v8.5zm31 21.5v5h-41.1c-26.4 0-41.7.4-43 1-2.1 1.2-2.5 4-.7 5.8.9.9 9.5 1.2 32.5 1.2H144v22H58v-22h5.4c6.8 0 9.5-2 7.3-5.4-1.4-2-2.4-2.1-17.1-2.4l-15.6-.3V185h127v5z" />
            </svg>
          </div>
        ) : props.type === "ztl" ? (
          <div className="flex items-center justify-center object-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 sm:h-9 w-6 sm:w-9  fill-current"
              // width={114.774}
              // height={76.995}
              viewBox="0 0 30.367 20.372"
              {...props}
            >
              <g
                style={{
                  fontWeight: 700,
                  fontSize: "14.8167px",
                  lineHeight: 1.25,
                  fontFamily: "Montserrat",
                  strokeWidth: 0.264583,
                }}
              >
                <path
                  d="M44.515 173.033v1.956h5.571l-5.69 6.86v1.556h9.068v-1.956h-5.897l5.675-6.86v-1.556zm9.332 0v1.956h3.32v8.416h2.4v-8.416h3.319v-1.956zm10.316 0v10.372h7.6v-1.956h-5.2v-8.416z"
                  aria-label="ZTL"
                  style={{
                    strokeWidth: 0.264583,
                  }}
                  transform="translate(-42.896 -168.033)"
                />
              </g>
            </svg>
          </div>
        ) : props.type === "zone30" ? (
          <div className="flex items-center justify-center object-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 sm:h-9 w-6 sm:w-9  fill-current"
              viewBox="0 0 43.019 31.219"
              {...props}
              style={{
                enableBackground: "new 0 0 16 16",
              }}
            >
              <text
                xmlSpace="preserve"
                x={73.196}
                y={162.53}
                style={{
                  fontWeight: 700,
                  fontSize: "14.8167px",
                  lineHeight: 1.25,
                  fontFamily: "Montserrat",
                  textAlign: "center",
                  textAnchor: "middle",
                  strokeWidth: 0.264583,
                }}
                transform="translate(-51.62 -151.98)"
              >
                <tspan
                  x={73.196}
                  y={162.53}
                  style={{
                    textAlign: "center",
                    textAnchor: "middle",
                    strokeWidth: 0.264583,
                  }}
                >
                  {"ZONE"}
                </tspan>
                <tspan
                  x={73.196}
                  y={182.996}
                  style={{
                    textAlign: "center",
                    textAnchor: "middle",
                    strokeWidth: 0.264583,
                  }}
                >
                  <tspan
                    style={{
                      fontStyle: "normal",
                      fontVariant: "normal",
                      fontWeight: 700,
                      fontStretch: "normal",
                      fontSize: "16.9333px",
                      fontFamily: "Montserrat",
                      fontVariantLigatures: "normal",
                      fontVariantCaps: "normal",
                      fontVariantNumeric: "normal",
                      fontVariantEastAsian: "normal",
                    }}
                  >
                    {"30"}
                  </tspan>
                </tspan>
              </text>
            </svg>
          </div>
        ) : (
          <div className="flex items-center justify-center object-center">
            <svg
              id="svg2"
              className="h-6 sm:h-9 w-6 sm:w-9  fill-current"
              xmlns="http://www.w3.org/2000/svg"
              x={0}
              y={0}
              viewBox="0 0 16 16"
              style={{
                enableBackground: "new 0 0 16 16",
              }}
              xmlSpace="preserve"
              {...props}
            >
              {/* <style>{".st1{fill:#ff0008}"}</style> */}
              <path
                className="st1"
                d="M12.7 9.6c-.4.7-1 1.2-1.8 1.4-1 .2-1.9.1-2.7-.6-1-.8-1.3-1.9-1-3.1.3-1 .9-1.6 1.8-2 1.3-.5 2.6-.2 3.6.7.4.2.4.6.2.8-.2.3-.6.3-.9 0-.3-.3-.7-.5-1.1-.6-.8-.2-1.5 0-2 .6s-.5 1.6 0 2.2c.4.5.9.7 1.5.6.6-.1 1-.4 1.3-.9.1-.1 0-.2-.1-.2h-.9c-.3 0-.5-.2-.5-.4-.1-.3 0-.5.2-.7.1-.1.2-.1.4-.1h3c.2 0 .3.1.3.3-.1.9 0 1.8 0 2.6 0 .3-.1.5-.4.6-.4.1-.8-.1-.8-.6 0-.1-.1-.3-.1-.6zM.3 8V5.8c0-.6.3-.8.8-.8H3c.7 0 1.3.3 1.6 1 .2.6.1 1.3-.4 1.7-.1.1-.1.1 0 .2.8.4.8 1.1.7 1.7-.1.7-.7 1.2-1.4 1.3-.8.1-1.6.1-2.4.1-.2 0-.4 0-.6-.1-.2-.1-.3-.3-.3-.5.1-.9.1-1.6.1-2.4zm2 1.9h.6c.4 0 .6-.2.7-.5.1-.5-.2-.9-.7-1H1.7c-.2 0-.2.1-.2.2v1c0 .2.1.3.3.3h.5zm0-2.5h.6c.3 0 .6-.3.6-.7 0-.3-.2-.6-.6-.6h-.7c-.7 0-.7-.1-.7.5 0 .9-.1.8.8.8zM6.7 8.8v1.5c0 .4-.2.6-.6.6-.4 0-.6-.2-.6-.6V7.1c.1-.4.3-.6.6-.5.3 0 .6.3.6.6v1.6zM14.5 8.8V7.3c0-.5.3-.7.8-.6.3.1.4.2.4.5v3.3c0 .4-.3.6-.7.6-.3 0-.5-.3-.5-.6V8.8zM6 6.3c-.3 0-.6-.3-.6-.7 0-.4.3-.6.7-.6.3 0 .6.3.6.6 0 .4-.3.7-.7.7zM15.8 5.7c0 .4-.3.6-.7.6-.4 0-.7-.3-.7-.7 0-.3.3-.6.6-.6.6 0 .8.2.8.7z"
              />
            </svg>
          </div>
        )}
      </button>
    </>
  );
};

export default LayerButton;
